import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { useState, useEffect, useReducer } from "react";
import { Form } from "react-bootstrap";
import "antd/dist/antd.css";
import "./styles-for-new-dashboard.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import mainLogoSerpMaze from "./Telescope-frontpage.png";
import { Spinner } from "react-bootstrap";
import DropdownButton from "../../components/DropdownButton";

import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  Bars3BottomLeftIcon,
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  XMarkIcon,
  CodeBracketIcon,
  ComputerDesktopIcon,
  PlusCircleIcon,
  PlusSmallIcon,
} from "@heroicons/react/24/outline";

import {
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  DashOutlined,
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  HeartOutlined,
  CaretDownOutlined,
  MonitorOutlined,
  FundTwoTone,
  RiseOutlined,
  DotChartOutlined,
  AreaChartOutlined,
  MailOutlined,
  CompassOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  SearchOutlined,
  CaretRightOutlined,
  QuestionCircleOutlined,
  ArrowRightOutlined,
  RedoOutlined,
  PlusCircleOutlined,
  GlobalOutlined,
  CheckOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Layout, Modal, Table, Alert, Menu as AntdMenu } from "antd";
import { Input } from "antd";
import { Col, Row, Card } from "antd";
import { Button } from "antd";
import { Dropdown, Space, message, Drawer } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  AreaChart,
  ReferenceLine,
  Area,
} from "recharts";
import googleDomainsForSelector from "../FreeSerpChecker/google-domains2.json";
import Select from "react-select";
import Loading from "../SpinnerAndError/Loading";
import ReportPageFromInsideApp from "../reportPageFromInsideApp/ReportPageFromInsideApp";
import SmallSpinner from "../SpinnerAndError/SmallSpinner";

const { Header, Content, Footer, Sider } = Layout;

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const NewDashboard = () => {
  const [numKeywordsLeft, setNumKeywordsLeft] = useState(0);
  const [
    overallNumberOfKeywordsForAllSites,
    setOverallNumberOfKeywordsForAllSites,
  ] = useState(null);
  const [numKeywordsAdded, setNumKeywordsAdded] = useState(0);

  const [allWebsiteData, setAllWebsiteData] = useState([]);
  const [indexNumberToDelete, setIndexNumberToDelete] = useState();
  const [loadings, setLoadings] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [selectedMednuItem, setSelectedMenuItem] = useState("Dashboard");
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]); //DATA FOR THE KEYWORD TABLE

  const [isModalOpen, setIsModal1Open] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isModal4Open, setIsModal4Open] = useState(false);
  const [domainNameEntered, setDomainNameEntered] = useState("");
  const [competitorFromInput, setCompetitorFromInput] = useState("");
  const [showModalNextButton, setShowModalNextButton] = useState(true);
  const [selectedGoogleDomain, setSelectedGoogleDomain] = useState();
  const [googleRegionsChosen, setGoogleRegionsChosen] = useState(false);
  const [deviceChosen, setDeviceChosen] = useState(false);
  const [country, setCountry] = useState("United States");
  const [googleDomain, setGoogleDomain] = useState("google.com");
  const [languageCode, setlanguageCode] = useState("en");
  const [countryCode, setCountryCode] = useState("us");
  const [device, setDevice] = useState("Mobile");
  const [editedKeywordsHasBeenChanged, setEditedKeywordsHasBeenChanged] =
    useState(false);
  const [keywordsFromModal, setKeywordsFromModal] = useState();
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);
  const [overallLoadingWithWarningText, setOverallLoadingWithWarningText] =
    useState(false);
  const [loadingAfterModal4, setLoadingAfterModal4] = useState(false);
  const [urlDoesNotExist, setUrlDoesNotExist] = useState(false);
  const [competitorDoesNotExist, setCompetitorDoesNotExist] = useState(false);
  const [browserTimedOut, setBrowserTimedOut] = useState(false);
  const [URLNotFound, setURLNotFound] = useState(false);
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [
    cannotUpdateNowHaveToWait24Hours,
    setCannotUpdateNowHaveToWait24Hours,
  ] = useState(false);
  const [
    lastTimeReportWasGeneratedPlus24Hours,
    setLastTimeReportWasGeneratedPlus24Hours,
  ] = useState("");
  //THESE BELOW ARE BEING SET ON COMPONENT DID MOUNT:

  const [subscriptionType, setSubscriptionType] = useState(50);
  const [payingUser, setPayingUser] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [keywords, setKeywords] = useState([]);
  const [trackingInformation, setTrackingInformation] = useState();
  const [email, setEmail] = useState();
  const [overallSEOScore, setOverallSEOScore] = useState();
  const [numberOfSuccessfullTests, setNumberOfSuccessfullTests] = useState();
  const [numberOfFailedTests, setNumberOfFailedTests] = useState();
  const [trackedWebsite, setTrackedWebsite] = useState();
  const [timeReportWasGenerated, setTimeReportWasGenerated] = useState();
  const [historyOfReports, setHistoryOfReports] = useState([]);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  // This below is the "Quickly Analyse" input field in the top for None-First Time users
  const [quicklyAnalyseInputField, setQuicklyAnalyseInputField] = useState("");

  // sider and drawer toggle
  const [visible, setVisible] = useState(false);
  const [isToggled, setToggled] = useState(false);

  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: true },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: false,
    },
    /*  {
      name: "Reports",
      icon: UsersIcon,
      href: "/saved-reports",
      current: false,
    }, */
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: false,
    },
    /* {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    }, */
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    { name: "Your Profile", href: "/profile" },
    /* { name: "Settings", href: "#" }, */
    { name: "Sign out", href: "#" },
  ];

  const secondaryNavigation = allWebsiteData?.map((data) => ({
    name: data.trackedUserDomain,
    href: "/keyword-tracker" + "?" + "id=" + data.trackedUserDomain,
    /* { name: "GraphQL API", href: "#" },
  { name: "Customer migration guides", href: "#" },
  { name: "Profit sharing program", href: "#" }, */
  }));

  useEffect(() => {
    // Wait until overallNumberOfKeywordsForAllSites has a non-null value
    if (overallNumberOfKeywordsForAllSites !== null) {
      const maxKeywords = getMaxKeywordsForSubscription();
      console.log("maxKeywords:", maxKeywords);
      const keywordsLeft =
        maxKeywords - (overallNumberOfKeywordsForAllSites + numKeywordsAdded);
      console.log("keywordsLeft", keywordsLeft);
      setNumKeywordsLeft(keywordsLeft > 0 ? keywordsLeft : 0);
    }
  }, [overallNumberOfKeywordsForAllSites, numKeywordsAdded]);

  const updateNumKeywordsLeft = (keywords) => {
    const maxKeywords = getMaxKeywordsForSubscription();
    console.log("Max Keywords:", maxKeywords);
    const numKeywords = keywords?.length || 0;
    console.log("numKeywords", numKeywords);
    const keywordsLeft =
      maxKeywords - (overallNumberOfKeywordsForAllSites + numKeywords);
    console.log(
      "overallNumberOfKeywordsForAllSites",
      overallNumberOfKeywordsForAllSites
    );
    console.log("keywordsLeft", keywordsLeft);
    setNumKeywordsLeft(keywordsLeft);
  };

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); // TURNING ON LOADER HERE
    fetchDataOnMount();
  }, [reRender]);

  //THIS IS THE FETCH DATA FUNCTION, THAT IE BEING CALLED ON COMPONENT DID MOUNT: *************************
  const fetchDataOnMount = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_EXISTING_USER_DATA_ON_LOGIN,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setOverallNumberOfKeywordsForAllSites(
          data.numberOfKeywordsBeingTracked
        ); // Overall number of keywords being tracked
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setPayingUser(data.paymentInformation.isCustomerPaying);
        setSubscriptionType(data.paymentInformation.subscriptionType);

        console.log("data;", data);

        //SETTING THE KWYWORDS IN STATE BELOW:
        const arrayOfKeywordsFromBackend = data?.keywords;
        const websites = data?.websites;
        setAllWebsiteData(websites); //adding all website data to state.

        if (Object.keys(websites)?.length > 0) {
          let newData = [];
          websites.forEach((e, outerIndex) => {
            let keywordData = [];
            e.keywords.forEach((data, innerIndex) => {
              keywordData.push({
                key: `${outerIndex}-${innerIndex}-${Date.now()}-${Math.random()}`,
                index: innerIndex + 1,
                keyword: data.keyword,
                position: data.currentRankingPosition,
              });
            });
            newData.push(keywordData);
          });
          setNewDataSourceForTheTable(newData);
        }
      } else if (response.status === 503) {
        const data = await response.json();
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setPayingUser(data.paymentInformation.isCustomerPaying);
      } else if (response.status === 401) {
        console.log("Token not valid");
        window.location.replace("/login"); // I AM ADDING THIS ONE , SO THAT THE USER WILL BE REDIRECTED TO THE LOGIN PAGE IN CASE THE TOKEN IS EXPIRED.
      }
    } catch (error) {
      console.log(error);
    }
  };

  //THIS IS T HE FUNCTION THAT OPENS UP THE DELETE SITE MODAL :

  const showDeleteSiteFunction = (index) => {
    console.log("Index Number:", index);
    setShowDeleteModal(true);
    setIndexNumberToDelete(index); //setting the index number in state so that I know which one to delete.
  };

  //THIS IS THE MODAL INFORMATION:
  const showModal1 = () => {
    setIsModal1Open(true);
    setIsModal2Open(false);
  };

  const showModal2 = () => {
    setIsModal1Open(false);
    setIsModal3Open(false);
    setIsModal2Open(true);
    setIsModal4Open(false);
  };

  const showModal3 = () => {
    setIsModal2Open(false);
    setIsModal4Open(false);
    setIsModal3Open(true);
  };
  const showModal4 = () => {
    setIsModal3Open(false);
    setIsModal2Open(false);
    setIsModal4Open(true);
  };

  const handleOk = (index) => {
    setIsModal1Open(false);
    setShowDeleteModal(false);
  };

  const handleCancel = () => {
    setIsModal1Open(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setShowDeleteModal(false);
  };

  const onChangeForModal4InputField = (event) => {
    const value = event.target.value; // Get the textarea content
    let keywords = value.split("\n"); // Split by new lines

    // Trim each keyword and make it lowercase
    keywords = keywords.map((keyword) => keyword.trim().toLowerCase());

    // Filter out any empty keywords
    keywords = keywords.filter((keyword) => keyword.length > 0);
    updateNumKeywordsLeft(keywords);
    const nonEmptyKeywords = keywords.filter((str) => str !== "");
    setKeywordsFromModal(nonEmptyKeywords);
  };

  const onChangeFunctionForUrlInput = (event) => {
    const result = event.target.value;
    const resultToLowerCase = result.replace(/[A-Z][a-z]*/g, (str) =>
      str.toLowerCase()
    );
    setDomainNameEntered(resultToLowerCase);
  };

  const onChangeFunctionForCompetitorInput = (event) => {
    const result = event.target.value.replace(
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,€<>\/?]+/,
      ""
    );
    setCompetitorFromInput(result);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, items) {
    return {
      key,
      icon,
      items,
      label,
    };
  }

  const customStylesWhenNotDisabled = {
    control: (base, state) => ({
      ...base,
      fontSize: "16px",
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      fontSize: "16px",
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      fontSize: "16px",
      padding: 0,
      color: "black",
    }),
  };

  const options = googleDomainsForSelector.sort((a, b) => {
    if (a.value.country_name < b.value.country_name) {
      return -1;
    }
    if (a.value.country_name > b.value.country_name) {
      return 1;
    }
    return 0;
  });

  const onChangeForGoogleRegion = (event) => {
    /* console.log(event); */
    setGoogleRegionsChosen(true);
    setCountry(event.value.country_name);
    setGoogleDomain(event.value.domain);
    setCountryCode(event.value.country_code);
    setlanguageCode(event.value.language_code);
  };

  //FOR THE DEVICE INPUT FIELD
  const deviceOptions = [
    { value: "Desktop", label: "Desktop" },
    { value: "Mobile", label: "Mobile" },
    { value: "Tablet", label: "Tablet" },
  ];

  const onChangeOfDeviceHandler = (change) => {
    setDevice(change.value);
    setDeviceChosen(true);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      fontSize: "16px",
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      fontSize: "16px",
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      fontSize: "16px",
      padding: 0,
      color: "black",
    }),
  };

  const handleSubmitForModal1 = (e) => {
    setUrlDoesNotExist(false);
    setErrorInFetching(false);
    e.preventDefault();
    setLoading(true);
    if (
      showModalNextButton === true &&
      domainNameEntered.length >= 4 &&
      !domainNameEntered.includes("@") &&
      !domainNameEntered.includes("!")
    ) {
      checkIfUrlExistsFunction();
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 1 ***************************:
  const checkIfUrlExistsFunction = async () => {
    console.log("working");

    const bodyData = {
      url: domainNameEntered,
    };

    try {
      const response = await fetch(process.env.REACT_APP_CHECK_IF_URL_EXISTS, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        console.log("url exists");
        setLoading(false);
        showModal2();
      } else if (response.status === 404) {
        console.log("Url does not exist");
        setUrlDoesNotExist(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 2 ***************************:
  const handleSubmitForModal2 = (e) => {
    e.preventDefault();
    setLoading(true);
    if (deviceChosen === true && googleRegionsChosen === true) {
      saveGoogleRegionAndDeviceInUsersProfile();
    }
  };

  const saveGoogleRegionAndDeviceInUsersProfile = async () => {
    const bodyData = {
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_SET_GOOGLE_REGION_AND_DEVICE_IN_USER_PROFILE,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        console.log("data saved");
        setLoading(false);
        showModal4();
      } else if (response.status === 404) {
        setLoading(false);
        setErrorInFetching(true);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 3 ***************************:
  const handleSubmitForModal3 = (e) => {
    /* console.log("Event", e.target.value); */
    setCompetitorDoesNotExist(false);
    setErrorInFetching(false);
    e.preventDefault();
    setLoading(true);
    if (competitorFromInput.length < 1) {
      setLoading(false);
      showModal4();
    } else {
      checkIfCompetitorExistsFunction();
    }
  };

  //THIS FUNCTION CHECK IF THE COMPETITOR URL EXISTS IN MODAL 3 ***************************:
  const checkIfCompetitorExistsFunction = async () => {
    const bodyData = {
      url: competitorFromInput,
    };

    try {
      const response = await fetch(process.env.REACT_APP_CHECK_IF_URL_EXISTS, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        console.log("competitor URL exists");
        setLoading(false);
        showModal4();
      } else if (response.status === 404) {
        console.log("Competitor URL does not exist");
        setCompetitorDoesNotExist(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS IS THE FUNCTION USED FOR THE 4TH MODAL FOR WHEN ADDING KEYWORDS
  const pushKeywordsFromModalFourToArrayFunction = (
    propertyName,
    targetValue
  ) => {
    const targetvalue2 = targetValue.replace(/[A-Z][a-z]*/g, (str) =>
      str.toLowerCase()
    );
    setEditedKeywordsHasBeenChanged(true);
    setKeywordsFromModal({
      ...keywordsFromModal,
      [propertyName]: targetvalue2,
    });
  };

  //THIS IS TEH FUNCTION WHEN YOU CLICK THE "FINISH SETUP" BUTTON IN MODAL 4.
  const setupAllInformationAfterModal4Function = async () => {
    setLoading(true);

    message.loading("keywords(s) are being added....", 5); // THIS IS THE LOADER ALERT IN THE TOP - WILL ONLY BE SHOWN IF THE USER IS "WITHIN THE LIMIT"
    const bodyData = {
      domainUrl: domainNameEntered,
      email: email, //used to identify the user on the backend.
      keywords: keywordsFromModal,
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };
    try {
      const response = await fetch(
        process.env.REACT_APP_FINISH_SETUP_OF_NEW_USER,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 201) {
        const update = await response.json();
        setLoading(false);

        /* setOverallLoadingWithWarningText(false); */

        console.log("Everything saved in MongoDB!");
        setIsModal1Open(false);
        setIsModal2Open(false);
        setIsModal3Open(false);
        setIsModal4Open(false);
        setDomainNameEntered("");
        setRerender([update]); // THIS IS JUST TO RE-RENDER THE COMPONENT
        message.info({
          content:
            "Please update the page in 1-2 minutes to see the ranking positions of your keyword(s).",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        setOverallLoadingWithWarningText(false);
        setLoading(false);
        setIsModal1Open(false);
        setIsModal2Open(false);
        setIsModal3Open(false);
        setIsModal4Open(false);
        window.location.href = "/dashboard";
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setOverallLoadingWithWarningText(false);
      setLoading(false);
      setErrorInFetching(true);
      setIsModal1Open(false);
      setIsModal2Open(false);
      setIsModal3Open(false);
      setIsModal4Open(false);
      window.location.href = "/dashboard";
    }
  };

  // THIS IS THE "QUICKLY ANALYSE A DOMAIN FUNCTION" BELOW *********************
  const quicklyAnalyseInputFieldFunction = async () => {
    console.log(quicklyAnalyseInputField);
    setLoading(true);
    setOverallLoading(true);

    const bodyData = {
      quicklyAnalyseURL: quicklyAnalyseInputField,
    };
    try {
      const response = await fetch(process.env.REACT_APP_QUICKLY_ANALYSE_URL, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        setLoading(false);
        setOverallLoading(false);
        console.log("Everything saved in MongoDB!");
        const update = await response.json();
        window.location.href = "/saved-reports";
        /*  setRerender([update]); */ // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        message.warning("Browser timed out. Go ahead and try again.");

        setOverallLoading(false);
        setLoading(false);
      } else if (response.status === 404) {
        setURLNotFound(true);
        message.error("URL not found. Are you sure you spelled it correctly?");
        setOverallLoading(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setOverallLoading(false);
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const runReportAgainFunction = async () => {
    setLoading(true);
    const bodyData = {
      trackedWebsite: trackedWebsite,
      email: email, //used to identify the user on the backend.
    };
    try {
      const response = await fetch(process.env.REACT_APP_RUN_REPORT_AGAIN, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        setLoading(false);
        const update = await response.json();
        setRerender([update]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 206) {
        setLoading(false);
        const data = await response.json();
        console.log("cannot update now - have to wait 24 hours.");
        setLastTimeReportWasGeneratedPlus24Hours(data.lastTimePlus24Hours);
        setCannotUpdateNowHaveToWait24Hours(true);
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const viewReportFromSummaryCardFunction = (event) => {
    event.preventDefault();
    console.log("Working");
    window.location.href = "/report";
  };

  const sendUserToTheKeywordTrackingFunction = (event) => {
    event.preventDefault();

    const websiteSelectedId = event.target
      .closest(".antd-card")
      .querySelector(".card-title").innerText;

    window.location.href = "/keyword-tracker" + "?" + "id=" + websiteSelectedId;
  };

  // THESE ARE THE COLUMNS USED FOR THE TABLE
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      /* width: 100, */
    },

    {
      title: "Keyword",
      dataIndex: "keyword",
      key: "keyword",
      /* width: 100, */
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      /* width: 100, */
      render: (value) => {
        if (value === 0) {
          return <SmallSpinner />;
        } else {
          return value;
        }
      },
    },
  ];

  const removeSiteFunction = async (event, index) => {
    setIsModal1Open(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setShowDeleteModal(false);

    const websiteIdToDelete = allWebsiteData[indexNumberToDelete].websiteId;

    const bodyData = {
      website: websiteIdToDelete,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_DELETE_A_SITE_FROM_DASHBOARD,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        console.log("Done");
        const data = await response.json();
        setNewDataSourceForTheTable([]);
        console.log(data);
        setRerender([data]);
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  const dropdownMenuForSmallNavForTheWebsite = (index) => (
    <AntdMenu
      style={{ maxWidth: "20px" }}
      items={[
        /* {
          key: "1",
          label: (
            <a rel="noopener noreferrer" href="/saved-reports">
              Analyse site
            </a>
          ),
        }, */
        {
          key: "2",
          label: (
            <a rel="noopener noreferrer" href="/keyword-tracker">
              Keyword tracker
            </a>
          ),
        },
        {
          key: "3",
          label: (
            <a
              rel={true.toString()}
              style={{ color: "red" }}
              onClick={() => showDeleteSiteFunction(index)}
            >
              Remove site
            </a>
          ),
        },
      ]}
    />
  );
  const addAnAdditionalSiteFunction = () => {
    console.log("hello there");
    setIsModal1Open(true);
    setIsModal2Open(false);
  };

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  const navigateToPricesPageFunction = () => {
    window.location.assign("https://serpmaze.com/#pricing");
  };

  const getMaxKeywordsForSubscription = () => {
    return subscriptionType || 1;
  };

  const packageNames = {
    50: "SEO Essentials",
    200: "SEO Growth",
    500: "SEO Mastery",
  };

  return (
    <div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div
                  style={{ cursor: "pointer" }}
                  className="flex flex-shrink-0 items-center px-4"
                >
                  <img
                    className="h-12 w-auto"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                    alt="SerpMaze"
                    onClick={takeMeToTheDashboardPage}
                  />
                </div>
                <div className="mt-5 h-0 flex-1 overflow-y-auto">
                  <nav className="space-y-1 px-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                          "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current
                              ? "text-gray-500"
                              : "text-gray-400 group-hover:text-gray-500",
                            "mr-3 flex-shrink-0 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </a>
                    ))}
                    <div className="space-y-1 mt-5">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "initial",
                          justifyContent: "space-between",
                          alignItems: "end",
                        }}
                      >
                        <h3
                          className="px-3 text-sm font-medium text-gray-500"
                          id="projects-headline"
                        >
                          Tracked sites
                        </h3>
                        <button
                          type="button"
                          className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          onClick={showModal1}
                          style={{ cursor: "pointer" }}
                        >
                          <PlusSmallIcon
                            className="h-4 w-4"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <div
                        className="space-y-1"
                        role="group"
                        aria-labelledby="projects-headline"
                      >
                        {secondaryNavigation?.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                          >
                            <span className="truncate">{item.name}</span>
                          </a>
                        ))}
                      </div>
                    </div>
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="w-14 flex-shrink-0" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        {/* <div className="hidden xl:block xl:fixed xl:inset-y-0 xl:w-64 xl:flex xl:flex-col"> */}
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
          <div
            style={{ cursor: "pointer" }}
            className="flex flex-shrink-0 items-center px-4"
          >
            <img
              className="h-12 w-auto"
              src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
              alt="SerpMaze"
              onClick={takeMeToTheDashboardPage}
            />
          </div>
          <div className="mt-5 flex flex-grow flex-col">
            <nav className="flex-1 space-y-1 px-2 pb-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "text-gray-500"
                        : "text-gray-400 group-hover:text-gray-500",
                      "mr-3 flex-shrink-0 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </a>
              ))}
              <div className="space-y-1 mt-5">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "initial",
                    justifyContent: "space-between",
                    alignItems: "end",
                  }}
                >
                  <h3
                    className="px-3 text-sm font-medium text-gray-500"
                    id="projects-headline"
                  >
                    Tracked sites
                  </h3>
                  <button
                    type="button"
                    className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={showModal1}
                    style={{ cursor: "pointer" }}
                  >
                    <PlusSmallIcon className="h-4 w-4" aria-hidden="true" />
                  </button>
                </div>
                <div
                  className="space-y-1"
                  role="group"
                  aria-labelledby="projects-headline"
                >
                  {secondaryNavigation?.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span className="truncate">{item.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      {/* // changed here */}
      <div className="flex flex-1 flex-col md:pl-64">
        {" "}
        <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
          <button
            type="button"
            className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex flex-1 justify-between px-4">
            <div className="flex flex-1">
              <form className="flex w-full md:ml-0" action="#" method="GET">
                <label htmlFor="search-field" className="sr-only">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                  {/* <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                      <MagnifyingGlassIcon
                        className="h-5 w-5"
                        aria-hidden="true"
                      />
                    </div> */}
                  <span
                  /*  id="search-field"
                    className="block h-full w-full border-transparent py-2  pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                    placeholder={email}
                    type="search"
                    name="search" */
                  />
                </div>
              </form>{" "}
            </div>
            <div className="ml-4 flex items-center md:ml-6">
              {/* Profile dropdown */}
              <Menu as="div" className="relative ml-3">
                <div>
                  <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                    <span className="sr-only">Open user menu</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <a
                            onClick={avatarOnClickFunction}
                            href={item.href}
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            {item.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>
        <main className="flex-1">
          <div className="py-6">
            {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Dashboard
                </h1>
              </div> */}
            <div className="">
              {" "}
              {/* mx-auto max-w-7xl px-4 sm:px-6 md:px-8 */}
              {/* Replace with your content */}
              {/*                 <div className="py-4">
                  <div className="h-96 rounded-lg border-4 border-dashed border-gray-200" />
                </div>
 */}
              {/* /End replace */}
              {overallLoading === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loading />
                </div>
              ) : overallLoadingWithWarningText === true ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p style={{ fontWeight: "600" }}>
                    Please hang on. We are analysing your keywords.
                  </p>

                  <p style={{ fontWeight: "600" }}>
                    This can take up to a couple of minutes.
                  </p>
                  <Loading />
                </div>
              ) : (
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      {/* //THIS BELOW IS THE "ANALYSE DOMAIN" SEARCH INPUT FIELD - I WILL ADD THAT ONE LATER */}
                      {/*  <div className="ant-card analysis-form-card ant-card-bordered">
                      <div className="ant-card-body">
                        <Input
                          style={{ borderRadius: "4px" }}
                          size="large"
                          placeholder="Analyse competitor. eg. competitor.com"
                          className="ant-input-top-main"
                          prefix={<SearchOutlined />}
                          onChange={(e) =>
                            setQuicklyAnalyseInputField(e.target.value)
                          }
                        />
                        <Button
                          type="primary"
                          size="large"
                          style={{
                            borderRadius: "4px",
                            background: "#28A745",
                            border: "none",
                          }}
                          onClick={quicklyAnalyseInputFieldFunction}
                          className="analyse-domain-button"
                        >
                          <span>Analyse Competitor</span>
                        </Button>
                      </div>
                    </div> */}

                      {/* // HERE I HAVE A CONDITIONAL RENDERING DEPENDING ON WHAT KIND OF USER */}

                      {firstTimeUser === false ? (
                        <div className="outer-wrapper-for-body-content">
                          {payingUser === false ? (
                            <Alert
                              message="Want to add more keywords?"
                              /* showIcon */
                              style={{ fontWeight: "500", marginBottom: "1em" }}
                              description="Upgrade now to add more keywords. Just $9/mo."
                              type="success"
                              action={
                                <Button
                                  onClick={navigateToPricesPageFunction}
                                  size="small"
                                  type="primary"
                                >
                                  Upgrade now
                                </Button>
                              }
                            />
                          ) : (
                            ""
                          )}
                          {payingUser === false ? (
                            <Alert
                              message={`You are tracking ${overallNumberOfKeywordsForAllSites} out of maximum 1 keyword for your website.`}
                              type="info"
                              style={{
                                borderRadius: "4px",
                                color: "#000",
                                fontWeight: "400",
                                marginBottom: "24px",
                                padding: "2em",
                              }}
                            />
                          ) : (
                            <Alert
                              message={`${
                                packageNames[subscriptionType] || "UNKNOWN"
                              } PACKAGE. You are tracking ${overallNumberOfKeywordsForAllSites} out of maximum ${subscriptionType} keywords for your website(s).`}
                              type="info"
                              style={{
                                borderRadius: "4px",
                                color: "#000",
                                fontWeight: "400",
                                marginBottom: "24px",
                                padding: "2em",
                              }}
                            />
                          )}

                          {/* <div className="ant-card-body"> */}
                          {/* THIS IS THE TOP "NAV" WHERE YOU CAN REMOVE THE SITE  */}
                          {allWebsiteData?.map((e, index) => {
                            return (
                              <div key={index} className="website-card">
                                <div
                                  style={{
                                    paddingLeft: "10px",
                                    fontSize: "19px",
                                    alignItems: "baseline",

                                    display: "flex",
                                    color: "#424747",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                      borderBottom: "3px solid #777B7C",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#28A745",
                                        display: "flex",
                                        paddingRight: "0.5em",
                                        alignItems: "center",
                                        fontSize: "23px",
                                      }}
                                    >
                                      <SettingOutlined />
                                    </div>
                                    <span
                                      style={{
                                        paddingBottom: "0.5em",
                                      }}
                                    >
                                      {" "}
                                      {e.trackedUserDomain}
                                    </span>

                                    <div
                                      style={{
                                        color: "#424747",
                                      }}
                                    >
                                      <DropdownButton
                                        index={index}
                                        dropdownMenuForSmallNavForTheWebsite={
                                          dropdownMenuForSmallNavForTheWebsite
                                        }
                                      />

                                      {/*   {allWebsiteData.map(
                                        (website, innerIndex) => (
                                          <Dropdown
                                            overlay={dropdownMenuForSmallNavForTheWebsite(
                                              index
                                            )}
                                            placement="bottomRight"
                                          >
                                            <Button
                                              style={{
                                                lineHeight: "1.499",
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                fontWeight: "600",
                                                borderRadius: "4px",
                                                borderColor: "#d9d9d9",
                                                color: "#777B7C",
                                                height: "30px",
                                                width: "30px",
                                                textAlign: "center",
                                                marginLeft: "8px",
                                              }}
                                            >
                                              <DashOutlined />
                                            </Button>

                                            
                                          </Dropdown>
                                        )
                                      )} */}
                                    </div>
                                  </div>
                                </div>
                                <Row>
                                  <Col xs={24} xl={24}>
                                    <Card
                                      className="antd-card"
                                      title={
                                        <div className="card-title-body">
                                          <span className="card-title">
                                            {e.trackedUserDomain}
                                          </span>
                                          <small>
                                            Your keywords for{" "}
                                            {e.trackedUserDomain}
                                          </small>
                                        </div>
                                      }
                                      extra={
                                        <div>
                                          <div
                                            className="card-link-div"
                                            style={{
                                              border: "solid green 2px",
                                            }}
                                            onClick={
                                              sendUserToTheKeywordTrackingFunction
                                            }
                                          >
                                            Check your keywords in detail{" "}
                                            <CaretRightOutlined />
                                          </div>
                                          &nbsp;&nbsp;
                                        </div>
                                      }
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      {Array.isArray(
                                        newDataSourceForTheTable
                                      ) && newDataSourceForTheTable.length ? (
                                        <Table
                                          /* scroll={{ x: 500 }} */
                                          pagination={{ pageSize: 8 }}
                                          dataSource={
                                            newDataSourceForTheTable[index]
                                          }
                                          columns={columns}
                                        />
                                      ) : (
                                        <div className="keywords-table">
                                          <Alert
                                            message="You haven't added any keywords to track yet."
                                            type="info"
                                            style={{
                                              borderRadius: "4px",
                                              color: "#000",
                                              fontWeight: "400",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </Card>
                                  </Col>
                                </Row>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        /* FIRST TIME USER === TRUE */
                        <div className="outer-wrapper-for-body-content">
                          <Row>
                            <Col xs={24} xl={24}>
                              <Card
                                className="first-time-user-card"
                                title={
                                  <div className="card-title-body">
                                    <span className="card-title">
                                      Welcome to SerpMaze!
                                    </span>
                                    <small>Let's track your keywords</small>
                                  </div>
                                }
                                extra={
                                  <div className="view-report-and-add-competitors-div"></div>
                                }
                                style={{
                                  width: "100%",
                                }}
                              >
                                <p>
                                  Let's start by tracking keywords for your
                                  first site.
                                </p>
                                <p>
                                  Adding keywords only takes a short time, and
                                  afterwards you will see rankings, volumes,
                                  competition and cpc for all your keywords.
                                </p>
                                <div>
                                  <span>
                                    <button
                                      style={{
                                        background: "#28A745",
                                        borderRadius: "4px",
                                        border: "none",
                                      }}
                                      onClick={showModal1}
                                      data-cy="add-new-tracked-website"
                                      type="button"
                                      className="ant-btn ant-btn-primary first-time-user-button"
                                      ant-click-animating-without-extra-node="false"
                                    >
                                      <span>Setup first site to track</span>
                                    </button>
                                    {/* MODAL 1. BELOW IS THE FIRST MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 1 */}
                                    <Modal
                                      title="Add a new website"
                                      open={isModalOpen}
                                      onOk={showModal2}
                                      onCancel={handleCancel}
                                      footer={[
                                        /* THIS FIRST BUTTON IS NOT BEING USED AND IS HIDDING USING CSS */
                                        {
                                          /* <Button key="back" */
                                        } /* onClick={handleCancel} */ >
                                          {
                                            /*    Return
                                </Button>,

                                <Button
                                  key="submit"
                                  type="primary"
                                  
                                  onClick={showModal2}
                                >
                                  Next
                                </Button>, */
                                          },
                                      ]}
                                    >
                                      <div>
                                        <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                                          <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                                            <div className="ant-steps-item-container">
                                              <div className="ant-steps-item-tail"></div>
                                              <div className="ant-steps-item-icon">
                                                <span className="ant-steps-icon">
                                                  1
                                                </span>
                                              </div>
                                              <div className="ant-steps-item-content">
                                                <div className="ant-steps-item-title">
                                                  Website
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="ant-steps-item ant-steps-item-wait">
                                            <div className="ant-steps-item-container">
                                              <div className="ant-steps-item-tail"></div>
                                              <div className="ant-steps-item-icon">
                                                <span className="ant-steps-icon">
                                                  2
                                                </span>
                                              </div>
                                              <div className="ant-steps-item-content">
                                                <div className="ant-steps-item-title">
                                                  Location
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {/*  <div className="ant-steps-item ant-steps-item-wait">
                                    <div className="ant-steps-item-container">
                                      <div className="ant-steps-item-tail"></div>
                                      <div className="ant-steps-item-icon">
                                        <span className="ant-steps-icon">
                                          3
                                        </span>
                                      </div>
                                      <div className="ant-steps-item-content">
                                        <div className="ant-steps-item-title">
                                          Competitors
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                                          <div className="ant-steps-item ant-steps-item-wait">
                                            <div className="ant-steps-item-container">
                                              <div className="ant-steps-item-tail"></div>
                                              <div className="ant-steps-item-icon">
                                                <span className="ant-steps-icon">
                                                  3
                                                </span>
                                              </div>
                                              <div className="ant-steps-item-content">
                                                <div className="ant-steps-item-title">
                                                  Keywords
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="ant-card-body modal-input-field-and-text-underneath">
                                          <form
                                            onSubmit={handleSubmitForModal1}
                                          >
                                            <Input
                                              style={{
                                                borderRadius: "4px",
                                                fontSize: "16px",
                                                spellCheck: "false",
                                                autocomplete: "off",
                                                autocorrect: "off",
                                                autocapitalize: "off",
                                              }}
                                              spellcheck="false"
                                              autocomplete="off"
                                              autocorrect="off"
                                              autocapitalize="off"
                                              size="large"
                                              placeholder="example: bbc.com"
                                              prefix={<GlobalOutlined />}
                                              onChange={
                                                onChangeFunctionForUrlInput
                                              }
                                              value={domainNameEntered}
                                              className="input-field-modal-1"
                                            />
                                            <small>
                                              Please note: You do not need to
                                              add http(s) or "www."
                                            </small>

                                            {urlDoesNotExist === true && (
                                              <div>
                                                <small style={{ color: "red" }}>
                                                  Url does not exist. Are you
                                                  sure you typed everything
                                                  correctly?
                                                </small>
                                                <br></br>
                                                <small style={{ color: "red" }}>
                                                  Please try again.
                                                </small>
                                              </div>
                                            )}

                                            {errorInFetching === true && (
                                              <div>
                                                <small style={{ color: "red" }}>
                                                  Sorry, something went wrong.
                                                  🙁
                                                </small>
                                                <br></br>
                                                <small style={{ color: "red" }}>
                                                  Please try again later.
                                                </small>
                                              </div>
                                            )}

                                            <div
                                              style={{
                                                textAlign: "end",
                                              }}
                                            >
                                              {showModalNextButton === true &&
                                              loading === false &&
                                              domainNameEntered.length >= 4 &&
                                              !domainNameEntered.includes(
                                                "@"
                                              ) &&
                                              !domainNameEntered.includes(
                                                "!"
                                              ) ? (
                                                <Button
                                                  key="submit1"
                                                  type="primary"
                                                  /* loading={loading} */
                                                  onClick={
                                                    handleSubmitForModal1
                                                  }
                                                >
                                                  Next
                                                </Button>
                                              ) : loading === true ? (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <Loading />
                                                </div>
                                              ) : (
                                                <Button
                                                  style={{
                                                    background: "grey",
                                                    border: "none",
                                                  }}
                                                  key="submit2"
                                                  type="primary"
                                                  /* loading={loading} */
                                                  onClick={
                                                    handleSubmitForModal1
                                                  }
                                                  disabled={true}
                                                >
                                                  Next
                                                </Button>
                                              )}
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </Modal>
                                    {/* MODAL 2. BELOW IS THE SECOND MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 1 */}
                                    <Modal
                                      title="Add a new website"
                                      open={isModal2Open}
                                      onOk={handleOk}
                                      onCancel={handleCancel}
                                      footer={[]}
                                    >
                                      <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                                        <div className="ant-steps-item ant-steps-item-finish">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                <i
                                                  aria-label="icon: check"
                                                  className="anticon anticon-check ant-steps-finish-icon"
                                                >
                                                  <CheckOutlined />
                                                </i>
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Website
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                2
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Location
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="ant-steps-item ant-steps-item-wait">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">3</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Competitors
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                                        <div className="ant-steps-item ant-steps-item-wait">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                3
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Keywords
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="ant-card-body modal-input-field-and-text-underneath">
                                        <p
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "15px",
                                          }}
                                        >
                                          Your target location
                                        </p>
                                        <p>
                                          Please enter the location of your
                                          primary target audience.
                                        </p>

                                        <Form.Group controlId="exampleForm.ControlSelect1">
                                          <Select
                                            placeholder="Search..."
                                            styles={customStylesWhenNotDisabled}
                                            options={options}
                                            value={selectedGoogleDomain}
                                            onChange={onChangeForGoogleRegion}
                                          />
                                        </Form.Group>
                                        <Form.Group controlId="exampleForm.ControlSelect1">
                                          <p
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "15px",
                                            }}
                                          >
                                            Primary device
                                          </p>
                                          <p>
                                            Please enter the primary device you
                                            would like to track your keywords
                                            ranking via.
                                          </p>

                                          <Select
                                            placeholder="Select..."
                                            options={deviceOptions}
                                            value={device?.device}
                                            onChange={onChangeOfDeviceHandler}
                                            styles={customStyles}
                                          />
                                        </Form.Group>
                                        {errorInFetching === true && (
                                          <div>
                                            <small style={{ color: "red" }}>
                                              Sorry, something went wrong. 🙁
                                            </small>
                                            <br></br>
                                            <small style={{ color: "red" }}>
                                              Please try again later.
                                            </small>
                                          </div>
                                        )}
                                      </div>
                                      <div className="ant-card-body modal-input-field-and-text-underneath">
                                        <form onSubmit={handleSubmitForModal2}>
                                          {loading === true ? (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                              }}
                                            >
                                              <div>
                                                <Loading />
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <Button
                                                style={{
                                                  background: "grey",
                                                  border: "none",
                                                  marginRight: "8px",
                                                }}
                                                key="submit3"
                                                type="primary"
                                                /* loading={loading} */
                                                onClick={showModal1}
                                              >
                                                Back
                                              </Button>
                                              {deviceChosen === true &&
                                              googleRegionsChosen === true ? (
                                                <Button
                                                  style={{ marginLeft: "8px" }}
                                                  key="submit4"
                                                  type="primary"
                                                  /* loading={loading} */
                                                  onClick={
                                                    handleSubmitForModal2
                                                  }
                                                >
                                                  Next
                                                </Button>
                                              ) : (
                                                <Button
                                                  style={{
                                                    background: "grey",
                                                    border: "none",
                                                    marginLeft: "8px",
                                                  }}
                                                  key="submit5"
                                                  type="primary"
                                                  /* loading={loading} */
                                                  onClick={showModal4}
                                                  disabled={true}
                                                >
                                                  Next
                                                </Button>
                                              )}
                                            </div>
                                          )}
                                        </form>
                                      </div>
                                    </Modal>
                                    {/* MODAL 3. BELOW IS THE THIRD MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 2 */}
                                    {/* MODAL 3 WILL BE ADDED LATER!!! */}
                                    {/*  <Modal
                              title="Add a competitor"
                              open={isModal3Open}
                              onOk={handleOk}
                              onCancel={handleCancel}
                              footer={[]}
                            >
                              <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                                <div className="ant-steps-item ant-steps-item-finish">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">
                                        <i
                                          aria-label="icon: check"
                                          className="anticon anticon-check ant-steps-finish-icon"
                                        >
                                          <CheckOutlined />
                                        </i>
                                      </span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Website
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-finish">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">
                                        <i
                                          aria-label="icon: check"
                                          className="anticon anticon-check ant-steps-finish-icon"
                                        >
                                          <CheckOutlined />
                                        </i>
                                      </span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Location
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">3</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Competitors
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-wait">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">4</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Keywords
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="ant-card-body modal-input-field-and-text-underneath">
                                <p
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                  }}
                                >
                                  Add a competitor of {domainNameEntered}
                                </p>
                                <p>
                                  To compare your SEO with one of your
                                  competitors you can add a competitors url.{" "}
                                </p>
                                <p>
                                  If you don't want to add a competitor right
                                  now - just leave the field blank.
                                </p>
                                <Input
                                  style={{ borderRadius: "4px" }}
                                  size="large"
                                  placeholder="example: competitor.com"
                                  prefix={<GlobalOutlined />}
                                  onChange={onChangeFunctionForCompetitorInput}
                                  value={competitorFromInput}
                                  className="input-field-modal-1"
                                />
                                <small>
                                  Please note: You do not need to add http(s) or
                                  "www."
                                </small>

                                {competitorDoesNotExist === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      URL does not exist. Are you sure you typed
                                      everything correctly?
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Please try again.
                                    </small>
                                  </div>
                                )}

                                {errorInFetching === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      Sorry, something went wrong. 🙁
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Please try again later.
                                    </small>
                                  </div>
                                )}
                              </div>
                              <div className="ant-card-body modal-input-field-and-text-underneath">
                                <form onSubmit={handleSubmitForModal3}>
                                  {loading === true ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Loading />
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Button
                                        style={{
                                          background: "grey",
                                          border: "none",
                                          marginRight: "8px",
                                        }}
                                        key="submit6"
                                        type="primary"
                                        
                                        onClick={showModal2}
                                      >
                                        Back
                                      </Button>

                                      <Button
                                        key="submit7"
                                        type="primary"
                                        
                                        onClick={handleSubmitForModal3}
                                      >
                                        Next
                                      </Button>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </Modal> */}
                                    {/* MODAL 4. BELOW IS THE FOURTH MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 3 */}
                                    <Modal
                                      title="Add your keywords"
                                      open={isModal4Open}
                                      onOk={handleOk}
                                      onCancel={handleCancel}
                                      footer={[]}
                                    >
                                      <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                                        <div className="ant-steps-item ant-steps-item-finish">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                <i
                                                  aria-label="icon: check"
                                                  className="anticon anticon-check ant-steps-finish-icon"
                                                >
                                                  <CheckOutlined />
                                                </i>
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Website
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="ant-steps-item ant-steps-item-finish">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                <i
                                                  aria-label="icon: check"
                                                  className="anticon anticon-check ant-steps-finish-icon"
                                                >
                                                  <CheckOutlined />
                                                </i>
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Location
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="ant-steps-item ant-steps-item-finish">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">
                                        <i
                                          aria-label="icon: check"
                                          className="anticon anticon-check ant-steps-finish-icon"
                                        >
                                          <CheckOutlined />
                                        </i>
                                      </span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Competitors
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                                        <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                                          <div className="ant-steps-item-container">
                                            <div className="ant-steps-item-tail"></div>
                                            <div className="ant-steps-item-icon">
                                              <span className="ant-steps-icon">
                                                3
                                              </span>
                                            </div>
                                            <div className="ant-steps-item-content">
                                              <div className="ant-steps-item-title">
                                                Keywords
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="ant-card-body modal-input-field-and-text-underneath">
                                        <p
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "15px",
                                          }}
                                        >
                                          Add keywords for {domainNameEntered}
                                        </p>
                                        <p>
                                          {payingUser === true ? (
                                            <span>
                                              Add up to{" "}
                                              <span
                                                style={{ fontWeight: "900" }}
                                              >
                                                {subscriptionType}
                                              </span>{" "}
                                              keywords to track.
                                            </span>
                                          ) : (
                                            <span>
                                              You are currently on the free
                                              plan, so you can only add{" "}
                                              <span
                                                style={{ fontWeight: "900" }}
                                              >
                                                1
                                              </span>{" "}
                                              keyword to track.
                                            </span>
                                          )}

                                          <p>
                                            You have{" "}
                                            <span style={{ fontWeight: "900" }}>
                                              {numKeywordsLeft}
                                            </span>{" "}
                                            keywords left.
                                          </p>
                                        </p>
                                        {numKeywordsLeft < 0 && (
                                          <span style={{ color: "red" }}>
                                            Sorry: You have exceeded the maximum
                                            number of keywords allowed for your
                                            subscription.
                                          </span>
                                        )}
                                        <div>
                                          <label
                                            htmlFor="comment"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            <span style={{ fontWeight: "900" }}>
                                              {" "}
                                              (Please add one keyword per line)
                                            </span>
                                          </label>
                                          <div className="mt-1">
                                            <textarea
                                              rows={4}
                                              style={{
                                                border: "solid green 1px",
                                                fontSize: "16px",
                                                padding: "0.5em",
                                                spellCheck: "false",
                                                autocomplete: "off",
                                                autocorrect: "off",
                                                autocapitalize: "off",
                                              }}
                                              spellcheck="false"
                                              autocomplete="off"
                                              autocorrect="off"
                                              autocapitalize="off"
                                              name="comment"
                                              id="comment"
                                              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                              defaultValue={""}
                                              placeholder="Add your keywords"
                                              onChange={
                                                onChangeForModal4InputField
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="ant-card-body modal-input-field-and-text-underneath">
                                        <form
                                          onSubmit={
                                            setupAllInformationAfterModal4Function
                                          }
                                        >
                                          {errorInFetching === true && (
                                            <div>
                                              <small style={{ color: "red" }}>
                                                Sorry, something went wrong. 🙁
                                              </small>
                                              <br></br>
                                              <small style={{ color: "red" }}>
                                                Please try again later.
                                              </small>
                                            </div>
                                          )}

                                          {browserTimedOut === true && (
                                            <div>
                                              <small style={{ color: "red" }}>
                                                Hmmmmm, {domainNameEntered}{" "}
                                                timed out. 🙁
                                              </small>
                                              <br></br>
                                              <small style={{ color: "red" }}>
                                                Please try again.
                                              </small>
                                            </div>
                                          )}

                                          {loading === true ? (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginTop: "1em",
                                              }}
                                            >
                                              <div>
                                                <small
                                                  style={{ color: "green" }}
                                                >
                                                  We are on it. Give us a couple
                                                  of seconds.🏃‍♀️
                                                </small>
                                                <br></br>
                                              </div>
                                              <div>
                                                <Loading />
                                              </div>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <Button
                                                style={{
                                                  background: "grey",
                                                  border: "none",
                                                  marginRight: "8px",
                                                }}
                                                key="submit8"
                                                type="primary"
                                                /* loading={loading} */
                                                onClick={showModal2}
                                              >
                                                Back
                                              </Button>

                                              {keywordsFromModal?.length > 0 ? (
                                                <Button
                                                  key="submit9"
                                                  type="primary"
                                                  /* loading={loading} */
                                                  disabled={numKeywordsLeft < 0}
                                                  onClick={
                                                    setupAllInformationAfterModal4Function
                                                  }
                                                >
                                                  Finish setup
                                                </Button>
                                              ) : (
                                                <Button
                                                  key="submit9"
                                                  disabled
                                                  type="primary"
                                                  /* loading={loading} */
                                                  onClick={
                                                    setupAllInformationAfterModal4Function
                                                  }
                                                >
                                                  Finish setup
                                                </Button>
                                              )}
                                            </div>
                                          )}
                                        </form>
                                      </div>
                                    </Modal>
                                  </span>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        </div>
                      )}
                      {/* //MODAL FOR THE DELETING OF A TRACKED SITE:  */}

                      <Modal
                        title="Are you sure?"
                        open={showDeleteModal}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        footer={[]}
                        className="modal-detete-button-outer-container"
                      >
                        <div
                          className="modal-delete-button-inner-container"
                          style={{
                            flexDirection: "row",
                            padding: "24px",
                          }}
                        >
                          <Button
                            style={{
                              width: "100%",
                              marginRigth: "12px",
                              backgroundColor: "#6c757d",
                              borderRadius: "0.25rem",
                              color: "white",
                              fontWeight: "400",
                              border: "none",
                              height: "2.8em",
                              fontSize: "1rem",
                            }}
                            className="modal-delete-button-no-button"
                            variant="secondary"
                            onClick={handleCancel}
                          >
                            No
                          </Button>
                          <Button
                            style={{
                              width: "100%",
                              fontSize: "1rem",
                              marginLeft: "12px",
                              backgroundColor: "#4aac48",
                              borderRadius: "0.25rem",
                              color: "white",
                              fontWeight: "400",
                              border: "none",
                              height: "2.8em",
                            }}
                            className="modal-delete-button-yes-button"
                            variant="success"
                            onClick={removeSiteFunction}
                          >
                            Yes
                          </Button>
                        </div>
                      </Modal>
                    </main>
                  </section>
                  {/* </div> */}
                  {/* MODAL 1. BELOW DOR ADDING AN ADDITIONAL WEBSITE! */}
                  <Modal
                    title="Add a new website"
                    open={isModalOpen}
                    onOk={showModal2}
                    onCancel={handleCancel}
                    footer={[]}
                  >
                    <div>
                      <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                        <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">1</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Website
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ant-steps-item ant-steps-item-wait">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">2</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Location
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="ant-steps-item ant-steps-item-wait">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">3</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Keywords
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <form onSubmit={handleSubmitForModal1}>
                          <Input
                            style={{
                              borderRadius: "4px",
                              fontSize: "16px",
                            }}
                            size="large"
                            placeholder="example: bbc.com"
                            prefix={<GlobalOutlined />}
                            onChange={onChangeFunctionForUrlInput}
                            value={domainNameEntered}
                            className="input-field-modal-1"
                          />
                          <small>
                            Please note: You do not need to add http(s) or
                            "www."
                          </small>

                          {urlDoesNotExist === true && (
                            <div>
                              <small style={{ color: "red" }}>
                                Url does not exist. Are you sure you typed
                                everything correctly?
                              </small>
                              <br></br>
                              <small style={{ color: "red" }}>
                                Please try again.
                              </small>
                            </div>
                          )}

                          {errorInFetching === true && (
                            <div>
                              <small style={{ color: "red" }}>
                                Sorry, something went wrong. 🙁
                              </small>
                              <br></br>
                              <small style={{ color: "red" }}>
                                Please try again later.
                              </small>
                            </div>
                          )}

                          <div
                            style={{
                              textAlign: "end",
                            }}
                          >
                            {showModalNextButton === true &&
                            loading === false &&
                            domainNameEntered.length >= 4 &&
                            !domainNameEntered.includes("@") &&
                            !domainNameEntered.includes("!") ? (
                              <Button
                                key="submit1"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal1}
                              >
                                Next
                              </Button>
                            ) : loading === true ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Loading />
                              </div>
                            ) : (
                              <Button
                                style={{
                                  background: "grey",
                                  border: "none",
                                }}
                                key="submit2"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal1}
                                disabled={true}
                              >
                                Next
                              </Button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Modal>
                  {/* MODAL 2. BELOW FOR ADDING AN ADDITIONAL WEBSITE */}
                  <Modal
                    title="Add a new website"
                    open={isModal2Open}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                  >
                    <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Website</div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">2</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Location</div>
                          </div>
                        </div>
                      </div>

                      <div className="ant-steps-item ant-steps-item-wait">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">3</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Keywords</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                      >
                        Your target location
                      </p>
                      <p>
                        Please enter the location of your primary target
                        audience.
                      </p>

                      <Form.Group controlId="exampleForm.ControlSelect1">
                        <Select
                          placeholder="Search..."
                          styles={customStylesWhenNotDisabled}
                          options={options}
                          value={selectedGoogleDomain}
                          onChange={onChangeForGoogleRegion}
                        />
                      </Form.Group>
                      <Form.Group controlId="exampleForm.ControlSelect1">
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          Primary device
                        </p>
                        <p>
                          Please enter the primary device you would like to
                          track your keywords ranking via.
                        </p>

                        <Select
                          placeholder="Select..."
                          options={deviceOptions}
                          value={device?.device}
                          onChange={onChangeOfDeviceHandler}
                          styles={customStyles}
                        />
                      </Form.Group>
                      {errorInFetching === true && (
                        <div>
                          <small style={{ color: "red" }}>
                            Sorry, something went wrong. 🙁
                          </small>
                          <br></br>
                          <small style={{ color: "red" }}>
                            Please try again later.
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <form onSubmit={handleSubmitForModal2}>
                        {loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <Loading />
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              style={{
                                background: "grey",
                                border: "none",
                                marginRight: "8px",
                              }}
                              key="submit3"
                              type="primary"
                              /* loading={loading} */
                              onClick={showModal1}
                            >
                              Back
                            </Button>
                            {deviceChosen === true &&
                            googleRegionsChosen === true ? (
                              <Button
                                style={{ marginLeft: "8px" }}
                                key="submit4"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal2}
                              >
                                Next
                              </Button>
                            ) : (
                              <Button
                                style={{
                                  background: "grey",
                                  border: "none",
                                  marginLeft: "8px",
                                }}
                                key="submit5"
                                type="primary"
                                /* loading={loading} */
                                onClick={showModal4}
                                disabled={true}
                              >
                                Next
                              </Button>
                            )}
                          </div>
                        )}
                      </form>
                    </div>
                  </Modal>

                  {/* MODAL 4. BELOW FOR ADDING AN ADDITIONAL WEBSITE */}
                  <Modal
                    title="Add your keywords"
                    open={isModal4Open}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                  >
                    <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Website</div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Location</div>
                          </div>
                        </div>
                      </div>

                      <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">3</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Keywords</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                      >
                        Add keywords for {domainNameEntered}
                      </p>
                      <p>
                        {payingUser === true ? (
                          <span>
                            Add up to{" "}
                            <span style={{ fontWeight: "900" }}>
                              {subscriptionType}
                            </span>{" "}
                            keywords to track.{" "}
                          </span>
                        ) : (
                          <span>
                            You are currently on the free plan, so you can only
                            add <span style={{ fontWeight: "900" }}>1</span>{" "}
                            keyword to track.{" "}
                          </span>
                        )}

                        <p>
                          You have{" "}
                          <span style={{ fontWeight: "900" }}>
                            {numKeywordsLeft}
                          </span>{" "}
                          keywords left.
                        </p>
                      </p>
                      {numKeywordsLeft < 0 && (
                        <span style={{ color: "red" }}>
                          Sorry: You have exceeded the maximum number of
                          keywords allowed for your subscription. Please
                          consider upgrading.
                        </span>
                      )}
                      <div>
                        <label
                          htmlFor="comment"
                          className="block text-sm font-medium text-gray-700"
                        >
                          <span style={{ fontWeight: "900" }}>
                            {" "}
                            (Please add one keyword per line)
                          </span>
                        </label>
                        <div className="mt-1">
                          <textarea
                            rows={4}
                            style={{
                              border: "solid green 1px",
                              fontSize: "16px",
                              padding: "0.5em",
                              spellCheck: "false",
                              autocomplete: "off",
                              autocorrect: "off",
                              autocapitalize: "off",
                            }}
                            spellcheck="false"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            name="comment"
                            id="comment"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            defaultValue={""}
                            placeholder="Add your keywords"
                            onChange={onChangeForModal4InputField}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <form onSubmit={setupAllInformationAfterModal4Function}>
                        {errorInFetching === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Sorry, something went wrong. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again later.
                            </small>
                          </div>
                        )}

                        {browserTimedOut === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Hmmmmm, {domainNameEntered} timed out. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again.
                            </small>
                          </div>
                        )}

                        {loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              marginTop: "1em",
                            }}
                          >
                            <div>
                              <small style={{ color: "green" }}>
                                We are on it. Give us a couple of seconds.🏃‍♀️
                              </small>
                              <br></br>
                            </div>
                            <div>
                              <Loading />
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              style={{
                                background: "grey",
                                border: "none",
                                marginRight: "8px",
                              }}
                              key="submit8"
                              type="primary"
                              /* loading={loading} */
                              onClick={showModal2}
                            >
                              Back
                            </Button>

                            {keywordsFromModal?.length > 0 ? (
                              <Button
                                key="submit9"
                                type="primary"
                                /* loading={loading} */
                                disabled={numKeywordsLeft < 0}
                                onClick={setupAllInformationAfterModal4Function}
                              >
                                Finish setup
                              </Button>
                            ) : (
                              <Button
                                key="submit9"
                                disabled
                                type="primary"
                                /* loading={loading} */
                                onClick={setupAllInformationAfterModal4Function}
                              >
                                Finish setup
                              </Button>
                            )}
                          </div>
                        )}
                      </form>
                    </div>
                  </Modal>
                </Content>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NewDashboard;
